import { render, staticRenderFns } from "./NotificationCardTwo.vue?vue&type=template&id=09e13c05"
import script from "./NotificationCardTwo.vue?vue&type=script&lang=js"
export * from "./NotificationCardTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports